/**
 * What the networks said about a number, in words. The HLR provider answers
 * in codes like ABSENT_SUBSCRIBER, which mean nothing to someone reading a
 * lead; these are what the codes mean for whether the lead is worth sending.
 */
export const PHONE_STATUS_LABELS: Record<string, string> = {
  LIVE: 'Live',
  DEAD: 'Disconnected',
  ABSENT_SUBSCRIBER: 'Switched off',
  NOT_APPLICABLE: 'Not a real mobile number',
  BAD_FORMAT: 'Badly formatted',
  INCONCLUSIVE: 'No clear answer',
  UNKNOWN: 'Unknown',
  NOT_VALIDATED: 'Not checked',
};

export function phoneStatusLabel(code: string): string {
  return PHONE_STATUS_LABELS[code.toUpperCase()] ?? code;
}

/** "HLR validation failed: phone status is NOT_APPLICABLE" as a sentence. */
export function plainPhoneReason(text: string): string {
  const m = /HLR validation failed: phone status is (\w+)/i.exec(text);
  return m ? `The network check said: ${phoneStatusLabel(m[1] ?? '').toLowerCase()}.` : text;
}
